/**
 * Import from node_modules
 */
// import 'bootstrap/js/src/scrollspy';

/**
 * Import site scripts
 */
import Menu from './site/menu';
import ScrollTo from './site/scrollTo';
import Header from './site/header';
import AOS from './site/aos';

/**
 * Init site scripts
 */
jQuery(function() {
	Menu.init();
	ScrollTo.init();
	Header.init();
	AOS.init();
});
